import { isChildOfSelector as o } from "@smh/utils/dom";
let c = !1;
const a = {
  isKeepAlive: !1,
  isCapture: !1,
  isSkipFirstClick: !0
}, r = /* @__PURE__ */ new Set(), n = (s, e, i) => o(e, s.target) ? !1 : (i(s), !0), l = (s) => {
  r.forEach((e) => {
    if (e.isFirstClick) {
      e.isFirstClick = !1;
      return;
    }
    const { selector: i, callback: t } = e;
    n(s, i, t) && !e.options.isKeepAlive && r.delete(e);
  }), r.size === 0 && (document.removeEventListener("click", l), c = !1);
}, u = (s, e, i = a) => {
  var t;
  c || (document.addEventListener("click", l, i.isCapture), c = !0), r.add({
    selector: s,
    callback: e,
    options: i,
    isFirstClick: (t = i.isSkipFirstClick) != null ? t : !0
  });
};
export {
  u as clickOutside
};
